export default __webpack_public_path__ + "4f1273cfbdb5222233635349d20989af.png";